/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { OperatorePredicato } from './operatore-predicato';
import { FontePredicato } from './fonte-predicato';


export interface TipoPraticaRegolaPunteggioPredicatoListFilter { 
    fonte?: FontePredicato;
    operatore?: OperatorePredicato;
}



